var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0501 20.5951C30.0501 15.0613 25.5589 10.5701 20.0251 10.5701C14.4912 10.5701 10 15.0613 10 20.5951C10 25.4473 13.4486 29.4874 18.0201 30.4197V23.6026H16.015V20.5951H18.0201V18.0889C18.0201 16.154 19.594 14.5801 21.5288 14.5801H24.0351V17.5876H22.0301C21.4787 17.5876 21.0276 18.0387 21.0276 18.5901V20.5951H24.0351V23.6026H21.0276V30.5701C26.0902 30.0688 30.0501 25.7981 30.0501 20.5951Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footer-facebook.f8c12661.svg";
export { ForwardRef as ReactComponent };